import { HttpClient } from '../HttpClient';
/**
 * * Get Project Employees
 */

export const GetProjectEmployees = async ({ ProjectID, PageNumber = 1, RowsPerPage = 10, SearchString, SortColumn, SortOrder }) => {
  try {
    const { data } = await HttpClient.get(`api/projects/${ProjectID}/Employees`, {
      params: {
        PageNumber,
        RowsPerPage,
        ...(SearchString ? { SearchString: SearchString } : {}),
        ...(SortColumn ? { SortColumn: SortColumn } : {}),
        ...(SortOrder ? { SortOrder: SortOrder } : {}),
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
